import { Observable, throwError } from 'rxjs';
import { Injectable, Output, EventEmitter } from '@angular/core';
import { HttpClient ,HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import { LogService } from '../logger/loggerProvider/loggerhelper.service';
import { AuthService } from './auth.service';
import { DashboardConfigManager } from './dashboard.config.service';
import { fail } from 'assert';
// import { JsonFormatter } from 'tslint/lib/formatters';


@Injectable()
export class CommonService {


    constructor(private authService: AuthService,
        private http: HttpClient,
        private logger: LogService,
        private dashboardConfig: DashboardConfigManager) {
    }

    public getSystemData() {
        try {

            this.logger.logInfo("CommonService", "Received login request!");

            if ((this.authService.HasValidSSO() && this.authService.HasValidToken()) === false) {
                this.authService.LoginWithSSO().subscribe(
                    response => {
                        if (response) {
                            this.getData();
                        }
                    }, error => {
                        this.logger.logError("CommonService", error);
                    });
            }
            else if (this.authService.HasValidToken()) {
                this.getData();
            } else {
                this.logger.logError("CommonService", "CommonService can not login to desigo cc.");
            }
        } catch (error) {

        }
    }

    private getData() {
        let baseUrl = this.dashboardConfig.getBaseUrl();
        let url: string = baseUrl + "/api/systems";
        //get token
        let token: any = this.authService.getToken();// window.sessionStorage.getItem("_token");
        let headers: HttpHeaders = new HttpHeaders();
        headers.append("Accept", "application/json");
        headers.append("Access-Control-Allow-Origin", "*");
        headers.append("Authorization", "Bearer " + token);
        this.http.get(url, {
            headers: headers
        }).subscribe(result => {
            var res = result as any;
            this.dashboardConfig.systemData = res /*&& result.json()*/ ? JSON.parse(res).Systems : [];
            this.dashboardConfig.hasSystemData = res /*&& result.json()*/ ? true : false;
            });
    }

    private handleError(error: any) {
        let errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        this.logger.logError("CommonService", "Error: " + errMsg);
        return throwError(errMsg);
    }

}